export default __webpack_public_path__ + "static/media/ai-mail-1.c6ceac81.png";